import { toast } from 'react-toastify';
import QRCode from 'react-qr-code';
import { useModal } from './ModalProvider';
import { tokenCreate } from '../utils/firebase';
import Spinner from './Spinner';
import Tooltip from './Tooltip';
import './InviteButton.scss';

export default function InviteButton({
  className,
  children,
  tokenCreatePayload,
  invited,
  showQR,
}) {
  const { openModal, closeModal } = useModal();

  const handleCopy = async (link) => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success('Link copied to the clipboard');
    } catch (error) {
      toast.error("Couldn't copy the link");
    }
  };

  const handlerInvite = async () => {
    try {
      openModal({
        header: 'Generating link...',
        body: (
          <div className='invite-generating-modal'>
            <p className='font-16'>An invitation link is being generated...</p>
            <Spinner show={true} />
          </div>
        ),
      });
      const res = await tokenCreate(tokenCreatePayload);
      closeModal();

      const link = `${process.env.REACT_APP_ROOT_URL}/invite/${res.data}`;
      openModal({
        header: `Invite ${invited}`,
        body: (
          <>
            <p className='font-16'>
              {showQR
                ? `Please send the link below to the ${invited} you want to invite or scan the QR-code:`
                : `Please send the link below to the ${invited} you want to invite:`}
              <br />
              <br />
              <span
                className='primary font-medium'
                style={{ wordBreak: 'break-all' }}
              >
                {link}
              </span>
              <Tooltip label='Copy to clipboard'>
                <button
                  className='transparent small'
                  style={{ display: 'inline' }}
                  onClick={() => handleCopy(link)}
                  aria-label='Copy to clipboard'
                >
                  <span className='fa-copy' />
                </button>
              </Tooltip>
            </p>
            {showQR && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '16px',
                }}
              >
                <QRCode value={link} size={200} />
              </div>
            )}
          </>
        ),
        buttons: [{ text: 'Ok' }],
      });
    } catch (error) {
      toast.error(error.message);
      closeModal();
    }
  };

  return (
    <button
      className={'small bw' + (className ? ' ' + className : '')}
      onClick={handlerInvite}
    >
      {children}
    </button>
  );
}
